import { Divider } from "@mui/material";
import { UserLogoutMenuItem, UserMenuItem } from "../styled";
import { BarekamIcon, IconVariants } from "../../../../components/icon/barekam-icon";
import BarekamText from "../../../../components/text";
import { ButtonType } from "../../header-button.enum";
import Message from "../../../../components/message";
import { MessageSections } from "../../../../components/message/message";
import WalletButton from "../../wallet-button/wallet-button";

const MobileUserButtons = ({ hasValidatedRecipient, handleButtonClick, isAdmin, isWarehouseWorker, isPdr }: MobileUserButtonsProps) => {
    if (isAdmin || isWarehouseWorker || isPdr) {
        return (
            <>
                <UserMenuItem onClick={() => handleButtonClick(ButtonType.MY_ADDRESSES)}>
                    <BarekamIcon variant={IconVariants.myAddresses} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'my_addresses'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserMenuItem>
                <UserMenuItem onClick={() => handleButtonClick(ButtonType.ACCOUNT_SETTINGS)}>
                    <BarekamIcon variant={IconVariants.user} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'account_settings'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserMenuItem>

                <Divider variant={'middle'} flexItem={true} light={true} />

                <UserLogoutMenuItem onClick={() => handleButtonClick(ButtonType.LOG_OUT)}>
                    <BarekamIcon variant={IconVariants.logOut} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'log_out'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserLogoutMenuItem>
            </>
        )
    } else {
        return (
            <>
                <UserMenuItem onClick={() => handleButtonClick(ButtonType.MY_ADDRESSES)}>
                    <BarekamIcon variant={IconVariants.myAddresses} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'my_addresses'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserMenuItem>

                <Divider variant={'middle'} flexItem={true} light={true} />

                {hasValidatedRecipient &&
                    <>
                        <UserMenuItem onClick={() => handleButtonClick(ButtonType.WALLET)}>
                            <WalletButton key={'wallet-button'} isDesktop={false} isTablet={false} hasValidatedRecipient={hasValidatedRecipient} />
                        </UserMenuItem>

                        <Divider variant={'middle'} flexItem={true} light={true} />
                    </>
                }

                <UserMenuItem onClick={() => handleButtonClick(ButtonType.ACCOUNT_SETTINGS)}>
                    <BarekamIcon variant={IconVariants.user} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'account_settings'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserMenuItem>

                <Divider variant={'middle'} flexItem={true} light={true} />

                {hasValidatedRecipient &&
                    <>
                        <UserMenuItem onClick={() => handleButtonClick(ButtonType.DELIVERY_ADDRESSES)}>
                            <BarekamIcon variant={IconVariants.home} />
                            <BarekamText variant={"m"} fontWeight={600}>
                                <Message messageKey={'delivery_addresses'} sectionId={MessageSections.MAIN} />
                            </BarekamText>
                        </UserMenuItem>

                        <Divider variant={'middle'} flexItem={true} light={true} />

                    </>
                }

                <UserMenuItem onClick={() => handleButtonClick(ButtonType.MY_RECIPIENTS)}>
                    <BarekamIcon variant={IconVariants.users} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'my_recipients'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserMenuItem>

                <Divider variant={'middle'} flexItem={true} light={true} />

                {hasValidatedRecipient &&
                    <>
                        <UserMenuItem onClick={() => handleButtonClick(ButtonType.SET_MONTHLY_LIMITS)}>
                            <BarekamIcon variant={IconVariants.wrench} />
                            <BarekamText variant={"m"} fontWeight={600} overflow="auto">
                                <Message messageKey={'set_monthly_limits'} sectionId={MessageSections.MAIN} />
                            </BarekamText>
                        </UserMenuItem>

                        <Divider variant={'middle'} flexItem={true} light={true} />
                    </>
                }

                <UserLogoutMenuItem onClick={() => handleButtonClick(ButtonType.LOG_OUT)}>
                    <BarekamIcon variant={IconVariants.logOut} />
                    <BarekamText variant={"m"} fontWeight={600}>
                        <Message messageKey={'log_out'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </UserLogoutMenuItem>
            </>
        )
    }
};

interface MobileUserButtonsProps {
    hasValidatedRecipient: boolean,
    handleButtonClick: (button: ButtonType) => void,
    isAdmin: boolean,
    isWarehouseWorker: boolean,
    isPdr: boolean,
}

export default MobileUserButtons;
